import _t from "../../../../../lang/translate";
import { LooseAutocomplete } from "../../../../../types/utilTypes";
import { AllFieldKeys } from "./types";

export const dataKeyLabels: Record<LooseAutocomplete<AllFieldKeys>, string> = {
  allDMRDocumentsRequestedAt: "Aktindsigt",
  repairRequestedAt: "Reparation påkrævet",
  obsoletedAt: "Arkiveret",

  nextDeadline: "Næste frist",
  governmentBatchId: "GruppeId",
  expectedConclusion: "Forv. afgørelse",
  caseStartAt: "Sagsstart",
  submissionDate: "Dato for indsendelse",
  submittedBy: "Indsendt af",
  dateForReception: "Dato for modtagelse",
  deadlineForNotation: "Frist for bemærkninger",
  governmentCaseHandlerId: "MS. sagsbehandler",
  outcomeType: "Sagens udfald",
  lackOfComplianceTags: "Mgl. regelefterlevelse",
  newPrice: "Nypris",
  equipmentsPrice: "Udstyrspris",
  tradePrice: "Handelspris",
  registrationFee: "Registreringsafgift",
  regulationAmount: "Regulering",
  governmentNewPriceAssessment: "MS. vurdering NP",
  governmentTradePriceAssessment: "MS. vurdering HP",
  penaltyTypeId: "Ansvarsvurdering",
  analysisTags: "Analyse",
  calledBack: "Tilbagekaldt",
  caseHandlerId: "Sagsbehandler",
  caseHandlerIdSANST: "SANST Sagsbehandler",
  caseIdSANST: "Sagsnummer SANST",
  conclusionDate: "Afgørelsesdato",
  deadlineForComplaint: "Dato for klagefrist",
  deadlineForDocumentation: "Frist for dokumentation",
  governmentCaseNumber: "Mst. sagsnummer",
  makingStatement: "Udtalelse",
  note: "Note",
  penaltyCaseId: "Straffesags-ID",
  receptionGovernmentCaseHandlerId: "Sagsbehandler",
  receptionGovernmentCaseNumber: "Sagsnummer",
  responseDate: "Dato for svar",
  statementDate: "Udtalelsesdato",
  statementDeadline: "Frist for udtalelse",
  statusId: "Status",
  submissionGovernmentCaseHandlerId: "Sagsbehandler",
  submissionGovernmentCaseNumber: "Sagsnummer",
  submissionReceiptDate: "kvitteringsdato",

  brand: "Mærke",
  model: "Model",
  firstRegDate: "1. reg. dato",
  mileage: "Kilometerstand",
  vin: "Stelnummer",

  activeStage: "Aktive stadie",
  complianceTags: "Mgl. regelefterlevelse",
  mstEquipmentPrice: "MS udstyrspris",
  mstNewPrice: "MS nypris",
  mstRegistrationFee: "MS registreringsafgift",
  mstTradePrice: "MS handelspris",
  regulationReduction: "Reguleringsnedsættelse",
  statuteOfLimitationsDate: "Forældelsesdato",

  reviewDate: _t("reviewDate"),
  dmfCaseId: "DMF sags-id",
  newPriceSourceTag: "Nypris kilde",
  equipmentPriceSourceTags: "Udstyrspris kilde",

  id: _t("id"),
  originalEvaluation: _t("original", "evaluation"),
  activeStageValues: _t("active", "values"),
  caseHandler: _t("caseHandler"),
  clientName: "Kundenavn",
  createdAt: _t("created_at"),
  dealerName: _t("dealer", "name"),
  files: _t("files"),
  importantNote: "Vigtig note",
  penaltyType: "Straffetype",
  relatedCases: _t(""),
  stages: "Stadier",
  status: _t("status"),
  vehicle: _t("vehicle")


};
